module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"noData":"No demographic data defined.","Estimated Monthly Earnings":"Estimated Monthly Earnings"},"es":{"noData":"No se han definido datos demográficos.","Estimated Monthly Earnings":"Ganancias mensuales estimadas"},"sw":{"noData":"Hakuna data ya idadi ya watu iliyofafanuliwa.","Estimated Monthly Earnings":"Makadirio ya Mapato ya Kila Mwezi"}}')
  delete Component.options._Ctor
}
